import React from 'react';
import { MapPinIcon, PhoneIcon, MessageCircleIcon, ClockIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
export function ServiceArea() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist py-20 sm:py-24" data-id="element-261" data-mp="s2wqdukvc46w">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[1fr_1.3fr] lg:items-center lg:px-8" data-id="element-262" data-mp="n9anuv8f5got">
        <div data-id="element-263" data-mp="11xyimzafxmdp">
          <p className="text-sm font-semibold text-brand-blue" data-id="element-264" data-mp="11xexzateojvz">{t.area.kicker}</p>
          <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-265" data-mp="wzdguvfjiun5">
            {t.area.title}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-ink/70" data-id="element-266" data-mp="16ycocaokkk8k">{t.area.subtitle}</p>

          <div className="mt-8 space-y-4 rounded-xl border border-navy/10 bg-white p-6 shadow-card" data-id="element-267" data-mp="16wi30v9dyq3y">
            <p className="flex items-start gap-3 text-sm text-ink/75" data-id="element-268" data-mp="3ct46xjr06wew">
              <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-269" data-mp="38raefyqyoypt" />
              <span data-id="element-270" data-mp="1a9rv9c2ygjz8">
                <span className="block font-semibold text-navy" data-id="element-271" data-mp="1a6424e1f9zl1">{t.area.radius}</span>
                {t.area.radiusNote}
              </span>
            </p>
            <p className="flex items-start gap-3 text-sm text-ink/75" data-id="element-272" data-mp="1k5crsup98s1l">
              <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-273" data-mp="1oxcyr73qsl7o" />
              <span data-id="element-274" data-mp="1twh6dtb0qavw">
                <span className="block font-semibold text-navy" data-id="element-275" data-mp="1tuwe6ac6f417">{t.area.hoursTitle}</span>
                {t.area.hours}
              </span>
            </p>
            <div className="flex flex-wrap gap-3 pt-2" data-id="element-276" data-mp="22wmbfwsqox6w">
              <a href={business.phoneHref} className="inline-flex items-center gap-2 rounded-lg bg-navy px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-navy-700" data-id="element-277" data-mp="22x5iujkrk36o">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="dhfw6g2ze2rz" />
                {t.area.callUs}
              </a>
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-navy/15 px-4 py-2.5 text-sm font-semibold text-navy transition-colors duration-150 hover:border-brand-blue hover:text-brand-blue" data-id="element-279" data-mp="5g894r1hvyf7">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-280" data-mp="ai5x1ykubheh" />
                {t.area.whatsapp}
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-hidden rounded-xl border border-navy/10 shadow-card" data-id="element-281" data-mp="kdr78k02bnzb">
          <iframe title={t.area.mapTitle} src={business.mapEmbed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-[420px] w-full border-0" data-id="element-282" data-mp="y4ch5j7jgnl2" />
        </div>
      </div>
    </section>;
}